import {
    isAuthenticated,
    getAccessToken,
    forceLocalLogout,
    handleSessionExpiredLogout,
} from "../features/auth/services/auth";

export const authFetch = async (input: RequestInfo, init: RequestInit = {}) => {
    const isAuth = await isAuthenticated(); // Refreshes token if needed
    if (!isAuth) {
        // Allow callers to gracefully fall back to anonymous fetch when not logged in.
        throw new Error("User is not authenticated");
    }

    const accessToken = getAccessToken();

    const headers = {
        ...(init.headers || {}),
        Authorization: `Bearer ${accessToken}`,
    };

    const response = await fetch(input, { ...init, headers });

    if (response.status === 401) {
        handleSessionExpiredLogout();
        return response;
    }

    // If backend indicates portal access is disabled for this contact, force a logout.
    if (!response.ok) {
        try {
            const cloned = response.clone();
            const data: any = await cloned.json();
            const message: string | undefined = data?.message ?? data?.error;
            if (message && message.toLowerCase().includes("portal access not enabled for this contact".toLowerCase())) {
                forceLocalLogout();
            }
        } catch {
            // If body is not JSON or cannot be read, ignore and let caller handle.
        }
    }

    return response;
};
